module.exports = __webpack_public_path__ + "static/media/country_al.0053e121.webp";